import React from 'react'

function Notes() {
  return (
<h1>Hello</h1>
  )
}

export default Notes
